'use client';

import { c as _c } from "react/compiler-runtime";
import { authClient } from '@/lib/auth-client';
import posthog from 'posthog-js';
import { useEffect } from 'react';
export function PosthogProvider(t0) {
  const $ = _c(3);
  const {
    children
  } = t0;
  const {
    data: session
  } = authClient.useSession();
  let t1;
  let t2;
  if ($[0] !== session) {
    t1 = () => {
      if (session) {
        posthog.identify(session.user.id, {
          email: session.user.email,
          name: session.user.name
        });
      }
    };
    t2 = [session];
    $[0] = session;
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  useEffect(t1, t2);
  return children;
}